import { createSelector } from 'reselect'
import { RootState } from 'store/rootReducer'

const trainingLogSelector = (s: RootState) => s.trainingLogs

export const getTrainingLogs = createSelector(
  trainingLogSelector,
  s => s.trainingLogs,
)
